// core/services/firebase/feedService.ts
import { 
  collection, 
  query, 
  where, 
  orderBy, 
  limit as firestoreLimit,
  getDocs,
  startAfter,
  QueryDocumentSnapshot
} from 'firebase/firestore';
import { db } from './config';
import { SocialPost } from '../../types/social';
import { followService } from './followService';

export const feedService = {
  /**
   * Get personalized feed (posts from followed users) using Fan-out architecture
   */
  async getPersonalizedFeed(
    userHandle: string, 
    limit: number = 20,
    lastVisible?: QueryDocumentSnapshot
  ): Promise<{ posts: SocialPost[], lastDoc: QueryDocumentSnapshot | null }> {
    // Agora consultamos a coleção de feeds individuais (Fan-out)
    // feeds/{userHandle}/items
    const feedsCollection = collection(db, 'feeds', userHandle, 'items');
    
    const q = lastVisible 
      ? query(
          feedsCollection,
          orderBy('createdAt', 'desc'),
          startAfter(lastVisible),
          firestoreLimit(limit)
        )
      : query(
          feedsCollection,
          orderBy('createdAt', 'desc'),
          firestoreLimit(limit)
        );

    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      return { posts: [], lastDoc: null };
    }

    const posts = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      // Converter Timestamps para Date
      createdAt: (doc.data().createdAt as any)?.toDate() || new Date()
    } as SocialPost));

    return {
      posts,
      lastDoc: snapshot.docs[snapshot.docs.length - 1] || null
    };
  },

  /**
   * Get global feed (all posts)
   */
  async getGlobalFeed(
    limit: number = 20,
    lastVisible?: QueryDocumentSnapshot
  ): Promise<{ posts: SocialPost[], lastDoc: QueryDocumentSnapshot | null }> {
    const q = lastVisible 
      ? query(
          collection(db, 'posts'),
          orderBy('createdAt', 'desc'),
          startAfter(lastVisible),
          firestoreLimit(limit)
        )
      : query(
          collection(db, 'social_posts'),
          orderBy('createdAt', 'desc'),
          firestoreLimit(limit)
        );

    const snapshot = await getDocs(q);
    const posts = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate() || new Date()
    } as SocialPost));

    return {
      posts,
      lastDoc: snapshot.docs[snapshot.docs.length - 1] || null
    };
  }
};
